// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q1/2026force/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

//是否显示表单
const showForm = () => {
  return http.get(`${urlPrefix}show-form`);
};

//提交表单抽奖
const submitForm = (data?: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

export { getBaseInfo, showForm, submitForm };
